import { actionAppStatusLoad } from '../actions/app/appStatus';

export const initializeStore = (store) => {
    
    store.dispatch(actionAppStatusLoad());
    
}